import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["select"];
  static values = { options: Array, selecteds: Array };

  connect() {
    const tom = new TomSelect(this.selectTarget, {
      valueField: "id",
      labelField: "full_name",
      searchField: ["full_name"],
      maxItems: 1,
      loadThrottle: 1000,
      options: this.optionsValue,
      items: this.selectedsValue,
      load: function (query, callback) {
        const url = "/courses?name=" + encodeURIComponent(query);
        const headers = { "Content-Type": "application/json" };
        fetch(url, { headers })
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback);
      },
    });

    const selectedId = (this.selectedsValue || [])[0];
    if (!selectedId || tom.options?.[selectedId]) return;

    fetch("/courses?id=" + encodeURIComponent(selectedId), {
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((json) => {
        if (!Array.isArray(json) || json.length === 0) return;
        const option = json[0];
        tom.addOption(option);
        tom.addItem(option.id, true);
      })
      .catch(() => {});
  }
}
